import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { baseConfig } from '@adornis/config/baseConfig.js';
import { XTinyMCE } from '@adornis/writer/x-tinymce.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';
import { filter, map } from 'rxjs';
import type { EditorOptions } from 'tinymce';

/**
 * @element tr-tinymce
 */
@customElement('tr-tinymce')
export class TrTinymce extends XTinyMCE {
  @property({ attribute: 'image', type: Boolean }) hasImage = new RXController(this, false);

  private editorOptionsList = new RXController(this, [
    'undo',
    'redo',
    '|',
    'bold',
    'italic',
    'underline',
    'strike-through',
    '|',
    'blocks',
    '|',
    'alignleft',
    'aligncenter',
    'alignright',
    '|',
    'link',
  ]);

  override editorOptions?: Partial<EditorOptions> | undefined = {
    toolbar: '',
    relative_urls: false,
    remove_script_host: false,
    document_base_url: baseConfig.get('ROOT_URL'),
  };

  override connectedCallback(): void {
    super.connectedCallback();

    this.hasImage.observable.pipe(filter(Boolean)).subscribe(() => {
      const list = this.editorOptionsList.value;
      list.push('image');
      this.editorOptionsList.next(list);
    });

    this.editorOptionsList.observable
      .pipe(
        filter(Boolean),
        map(array => array.join(' ')),
      )
      .subscribe(toolbar => {
        if (!this.editorOptions) return;

        this.editorOptions.toolbar = toolbar;
      });
  }

  override render() {
    return html`
      <x-flex space="xs">
        <x-flex
          horizontal
          space-between
          space="sm"
          ${css({
            marginLeft: '0',
            opacity: '1',
            transform: 'translateY(0)',
            transition: 'opacity .12s ease, transform .12s ease, max-height .12s ease, margin .12s ease',
            color: this.error ? this.colors.tone.error : undefined,
            userSelect: 'none',
          })}
        >
          <x-text ${css({ color: this.colors.tone.placeholder, display: 'inline-block' })}>
            ${this.placeholder}
          </x-text>
          ${this.error
            ? html`
                <x-text
                  ellipsis
                  flex
                  title=${this.error}
                  .value=${this.error}
                  ${css({ color: this.colors.tone.error, display: 'inline-block' })}
                >
                </x-text>
              `
            : nothing}
        </x-flex>
        <x-flex space="sm" h100>
          <textarea
            ${ref(textarea => this._inittiny(textarea as HTMLTextAreaElement | undefined))}
            .value=${this.value.value ?? ''}
          ></textarea>
        </x-flex>
        ${this._loader()}
      </x-flex>
    `;
  }
}
